import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { STR_BUY_NOW, STR_OPEN, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_RESERVED, STR_SUBSCRIPTION_HAS_EXPIRED } from "../Strings";
import { MdCall, MdMessage, MdWhatsapp } from "react-icons/md";

export default function View({ data, viewer, hotelData }) {
	const appContext = useContext(AppContext);

	/* Place states here */
	const [realPricePerDay, setRealPricePerDay] = useState(0);

	function view() {
		if(viewer === 'manager') {
			appContext.navTo({
				item: "side-view",
				subItem: "manage-hotel-room",
				extraItem: data.id,
			});
		} else {
			appContext.navTo({
				item: "side-view",
				subItem: "hotel-room",
				extraItem: data.id,
			});
		}
	}

	function getRealPricePerDay() {
		if(data && hotelData) {
			let _price = Number(data.pricePerDay) * (1 + (Number(hotelData.platformFeePercent)/100));

			setRealPricePerDay(_price);
		}
	}

	useEffect(() => {
		getRealPricePerDay()
	}, [ data, hotelData ])

	return (
		<div
			className=""
			onClick={view}
			style={{
				width: "100%",
				height: "190px",
				paddingTop: "100%",
				padding: "0",
				borderRadius: "20px",
				overflow: "hidden",
				position: 'relative',
				marginBottom: "10px",
				backgroundImage: `url(${CDN_URL + data.photo1})`,
				backgroundPosition: 'center',
				backgroundSize: 'cover'
			}}
		>

			<div
				style={{
					width: "100%",
					height: "100%",
					background: "linear-gradient(to bottom, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 1) 100%)",
				}}
			>
				<span
					style={{
						position: "absolute",
						top: "10px",
						right: "10px",
						background: (data.isAvailable === 'yes' && data.isBooked === 'no') ? "var(--secondaryColor)" : "var(--darkColor)",
						color: (data.isAvailable === 'yes' && data.isBooked === 'no') ? "var(--onSecondaryColor)" : "var(--lighColor)",
						textTransform: "uppercase"
					}}
					className="badge"
				>
					{(data.isAvailable === 'yes' && data.isBooked === 'no') ? STR_OPEN[appContext.language] : STR_RESERVED[appContext.language]}
				</span>
				<h6
					style={{
						fontSize: "18px",
						position: 'absolute',
						bottom: "0",
						left: "0",
						padding: "8px",
						width: "100%"
					}}
					className="text-light font-bold"
				>
					<span
						className="badge bg-surface font-bold"
						style={{
							fontSize: "16px"
						}}
					>
						{formatMoney(realPricePerDay)} <span className="font-light">TZS</span>
					</span>
					
					<span className="d-block">{data.name}</span>

				</h6>

				
			</div>

			
		</div>
	);
}
